import { Pipe, PipeTransform } from '@angular/core';

import { Partition } from '@classes/simulation/partition';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';
import { PartitionType } from '@enums/partition-type.enum';

@Pipe({
    name: 'partitionsFlagFilter',
    pure: false
})
export class PartitionsFlagFilterPipe implements PipeTransform {

    transform(partitions: Partition[], flag: SimulationFlagType): Partition[] {
        if (!partitions) {
            return [];
        }

        if (!flag) {
            return partitions;
        }

        return partitions.filter(p => p.simulationValues.flag === flag
            || p.partitionDetails.partitionType === PartitionType.funding
            || p.partitionDetails.partitionType === PartitionType.invest
            || p.partitionDetails.partitionType === PartitionType.simulationFile
            );
    }

}
